import { BoxContainer } from '@/components';
import { Content } from '@prismicio/client';
import { SliceComponentProps } from '@prismicio/react';
import { OurHistoryInner } from './OurHistoryInner/OurHistoryInner';

import { JSX } from 'react';
import styles from './styles.module.scss';

export type OurHistoryProps = SliceComponentProps<Content.OurHistorySlice>;

const OurHistory = ({ slice }: OurHistoryProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      id={slice.id}
    >
      <BoxContainer styles={styles.box_container}>
        <OurHistoryInner data={slice.primary} />
      </BoxContainer>
    </section>
  );
};

export default OurHistory;
